import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'config/theme/baseTheme';

export const useStyles = makeStyles((theme) => ({
  dropdownButton: {
    height: '38px',
    borderRadius: '8px',
    textTransform: 'none',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: COLORS.PRIMARY_MAIN,
      boxShadow: 'none',
    },
    '& svg': {
      '& path': {
        fill: COLORS.WHITE,
      }
    }
  },
  paper: {
    marginTop: theme.spacing(1),
    minWidth: '200px',
    maxHeight: '350px',
    display: 'flex',
    flexDirection: 'column',
  },
  searchContainer: {
    padding: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  listContainer: {
    maxHeight: '200px',
    overflow: 'auto',
    flex: 1,
  },
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.selected': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  buttonContainer: {
    padding: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  clearButton: {
    borderRadius: '6px',
    border: '1px solid ' + theme.palette.primary.main,
    textTransform: 'none',
    padding: theme.spacing(0.5, 2.5),
    minWidth: '90px',
    height: '32px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  applyButton: {
    borderRadius: '6px',
    border: 'none',
    textTransform: 'none',
    padding: theme.spacing(0.5, 2.5),
    minWidth: '90px',
    height: '32px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  noResults: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  clickableBox: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  labelText: {
    fontSize: '12px',
    fontWeight: 500,
  },
  primaryText: {
    fontSize: '12px',
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  dropdownIcon: {
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  popper: {
    zIndex: 1300,
  },
  loadingSpinner: {
    marginRight: 8,
  },
}));
